import React from "react";
import classNames from "classnames";
import {
    RuleGroupType,
    TransactionRuleGroup,
} from "@common/types/transactionRule";
import styles from "../RulesTable.module.scss";
import { GroupHeaderCell } from "./GroupHeaderCell";

/**
 * EmptyState displays when a group has no rules.
 */
interface EmptyStateProps {
    readonly group: TransactionRuleGroup;
    readonly groupListeners?: React.HTMLAttributes<HTMLElement>;
    readonly groupAttributes?: React.HTMLAttributes<HTMLElement>;
    readonly highlight?: boolean;
    readonly priority?: number;
}

export const EmptyState: React.FC<EmptyStateProps> = ({
    group,
    groupListeners,
    groupAttributes,
    highlight,
    priority,
}) => (
    <>
        <GroupHeaderCell
            group={group}
            groupListeners={groupListeners}
            groupAttributes={groupAttributes}
            priority={priority}
        />
        <td
            className={classNames(styles.td, highlight && styles.selected)}
            colSpan={group.type === RuleGroupType.TRANSFER ? 4 : 5}
        >
            No rules in this group
        </td>
    </>
);
